import { SWAN_STYLE_KEY_MAP } from '@vp/swan';

export const DesignServicesSwanStyleKeys = [SWAN_STYLE_KEY_MAP.hidden, SWAN_STYLE_KEY_MAP.visible];
